import { RobotsHistory } from "../../../../generated/graphql";

export const findItemByOrder = (order: number, items: RobotsHistory[]) => {
  if (Array.isArray(items)) {
    return items.find((e) => e.order === order);
  }
};
